import { render, staticRenderFns } from "./EspondiloartritesDiseaseActivityPhase.vue?vue&type=template&id=260c3672&"
import script from "./EspondiloartritesDiseaseActivityPhase.vue?vue&type=script&lang=js&"
export * from "./EspondiloartritesDiseaseActivityPhase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports